exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card_animate[data-v-4cc9f926]{overflow:hidden;-webkit-transition:.5s;transition:.5s}.text-primary-cus[data-v-4cc9f926]{color:var(--systemMainColor)}", ""]);

// exports
